import { EntitySupplier } from "../../entity/EntitySupplier";

export class DtoSuppliersPostRes extends EntitySupplier {}
